const DIGITS_ONLY = /\D+/g

export const normalizeWhatsAppPhoneAR = (input) => {
  const raw = typeof input === 'string' || typeof input === 'number' ? String(input) : ''
  const digits = raw.replace(DIGITS_ONLY, '')
  if (!digits) return { normalized: '', isValid: false, reason: 'empty' }

  if (/^549\d{10}$/.test(digits)) return { normalized: digits, isValid: true, reason: 'ok' }

  if (/^54\d{10}$/.test(digits)) {
    const normalized = `549${digits.slice(2)}`
    return { normalized, isValid: /^549\d{10}$/.test(normalized), reason: 'added_9' }
  }

  if (/^9\d{11}$/.test(digits)) {
    const normalized = `54${digits}`
    return { normalized, isValid: /^549\d{10}$/.test(normalized), reason: 'added_54' }
  }

  if (/^0\d{10,11}$/.test(digits)) {
    const noZero = digits.slice(1)
    if (/^9\d{11}$/.test(noZero)) {
      const normalized = `54${noZero}`
      return { normalized, isValid: /^549\d{10}$/.test(normalized), reason: 'removed_0_added_54' }
    }
    if (/^\d{10}$/.test(noZero)) {
      const normalized = `549${noZero}`
      return { normalized, isValid: /^549\d{10}$/.test(normalized), reason: 'removed_0_added_549' }
    }
  }

  return { normalized: digits, isValid: false, reason: 'invalid_format' }
}

export const isValidWhatsAppPhoneAR = (input) => normalizeWhatsAppPhoneAR(input).isValid

export const buildWhatsAppLinkAR = (phone, text = null) => {
  const { normalized, isValid } = normalizeWhatsAppPhoneAR(phone)
  if (!isValid) return null
  if (typeof text === 'string' && text.trim()) {
    return `https://wa.me/${normalized}?text=${encodeURIComponent(text)}`
  }
  return `https://wa.me/${normalized}`
}

